import { getI18n, ROUTES, registerEntityEndpoint } from "@editor/ui-utils";
import { QSelect } from "quasar";
import { defineComponent, ref, computed, onMounted, createBlock, openBlock } from "vue";
import { useI18n } from "vue-i18n";
const de = {
  articleListApi: {
    createAlreadyExists: "ArticleList kann nicht erstellt werden, da bereits ein ArticleList mit diesem Namen existiert",
    updateAlreadyExists: "ArticleList kann nicht aktualisiert werden, da bereits ein ArticleList mit diesem Namen existiert",
    created: "ArticleList erstellt",
    updated: "ArticleList aktualisiert",
    notFound: "ArticleList nicht gefunden",
    requiredFields: "Sie können den ArticleList nicht speichern, da obligatorische Informationen fehlen",
    referencedByChannel: "ArticleList wird noch von einigen Kanälen referenziert"
  },
  articleListList: {
    newButton: "Neue Artikel-liste",
    name: "Nach Listennamen suchen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade ArticleList",
    headerLabel: "Listenname",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    errorOnDeleting: "Fehler beim Löschen",
    createArticleList: "ArticleList erstellen"
  },
  articleList: {
    articleListLabel: "ArticleList",
    backButton: "Zurück zur ArticleList-Liste",
    newArticleList: "Neues List",
    deleteArticleList: "Löschen",
    messageDeleted: "List gelöscht",
    messageDeleteArticleList: "Sind Sie sicher, dass Sie dieses List löschen möchten?",
    messageDeleteArticleListTitle: "List löschen",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des ArticleLists",
    errorFailedLoadedArticleListWithId: "Es gab einen Fehler beim Abrufen des ArticleLists",
    handledInLegacySystem: "Dieser ArticleList wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten"
  },
  articleListEdit: {
    title: "Inhalt auflisten",
    placeholder: "Artikel hier platzieren",
    selectArticle: "Artikel auswählen",
    loading: "Laden",
    label: "Listenname",
    previouslySelectedMessage: "Zuvor für die Liste ausgewählt",
    saveAndPublish: "Speichern und veröffentlichen",
    revertChanges: "Aktuelle Änderungen abbrechen",
    counter: "Zähler",
    searchByTitleOrKicker: "Suche nach Artikel-Vorzeile oder -Hauptzeile",
    backButton: "Zurück zur ArticleList-Liste",
    editArticleList: "Artikellisten bearbeiten",
    messageSaved: "Neues ArticleList gespeichert",
    errorWrongBrand: "Alle Artikel in der Liste sollten zu einer einzigen Marke gehören",
    errorWrongState: "Alle Artikel in der Liste müssen im Veröffentlichungsstatus sein",
    errorNoArticles: "Die Artikelliste muss mindestens einen gültigen Artikel enthalten",
    errorDontChangeBrand: "Die Marke der Artikelliste kann nicht geändert werden",
    canNotCreateNewList: "Sie haben keine Rechte zum Erstellen einer neuen Artikelliste",
    revertChangesConfirmationDialogTitle: "Sie haben unveröffentlichte Änderungen",
    revertChangesConfirmationDialogMessage: "Sind Sie sicher, dass Sie alle Änderungen an der Liste seit der letzten Speicherung zurücksetzen möchten?",
    revertChangesConfirmationDialogOk: "Ja, Änderungen zurücksetzen",
    revertChangesConfirmationDialogCancel: "Nein, Änderungen beibehalten",
    removeArticleFromPreviouslyUsedArticlesTitle: "Artikel aus den verwendeten Artikeln entfernen",
    removeArticleFromPreviouslyUsedArticlesMessage: "Sind Sie sicher, dass Sie diesen Artikel aus den zuvor verwendeten Artikeln in der Liste entfernen möchten?"
  }
};
const en = {
  articleListApi: {
    createAlreadyExists: "Can't create ArticleList because another ArticleList with this name already exists",
    updateAlreadyExists: "Can't update ArticleList because another ArticleList with this name already exists",
    created: "ArticleList created",
    updated: "ArticleList updated",
    notFound: "ArticleList not found",
    requiredFields: "You can't save the ArticleList because mandatory information is missing",
    referencedByChannel: "ArticleList is still referenced by some channels"
  },
  articleListList: {
    newButton: "New List",
    name: "Search by list name",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading ArticleList",
    headerLabel: "List Name",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    errorOnDeleting: "Error on deleting",
    createArticleList: "Create ArticleList"
  },
  articleList: {
    articleListLabel: "ArticleList",
    backButton: "Back to ArticleList list",
    newArticleList: "New Article List",
    deleteArticleList: "Delete",
    messageDeleted: "List Deleted",
    messageDeleteArticleList: "Are you sure you want to delete this list?",
    messageDeleteArticleListTitle: "Delete list",
    errorOnDeleting: "There was an error deleting the ArticleList ",
    errorFailedLoadedArticleListWithId: "There was an error getting the ArticleList",
    handledInLegacySystem: "This ArticleList is being handled in {source}, you can't edit it on Vibe"
  },
  articleListEdit: {
    title: "List content",
    placeholder: "Place article here ",
    selectArticle: "Select Article",
    loading: "Loading",
    saveAndPublish: "Save and Publish",
    revertChanges: "Cancel current changes",
    previouslySelectedMessage: "Previously selected for the list",
    label: "List Name",
    counter: "Counter",
    backButton: "Back to ArticleList list",
    editArticleList: "Edit Article List",
    searchByTitleOrKicker: "Search by title or kicker",
    messageSaved: "New ArticleList saved",
    errorWrongBrand: "All articles in the list should belong to a single brand",
    errorWrongState: "All articles in the list needs to be in publish state",
    errorNoArticles: "A minimum of one valid article is required in the article list",
    errorDontChangeBrand: "ArticleList brand cannot be changed",
    canNotCreateNewList: "You do not have rights to create new Article List",
    revertChangesConfirmationDialogTitle: "You have unpublished changes",
    revertChangesConfirmationDialogMessage: "Are you sure you want to revert all changes made to the list since the last save?",
    revertChangesConfirmationDialogOk: "Yes, revert changes",
    revertChangesConfirmationDialogCancel: "No, keep changes",
    removeArticleFromPreviouslyUsedArticlesTitle: "Remove Article from Used Articles",
    removeArticleFromPreviouslyUsedArticlesMessage: "Are you sure you want to remove this article from the previously used articles in the list ?"
  }
};
const messages = { en, de };
const routes = [
  {
    path: `/${ROUTES.articleList.path}`,
    meta: { i18RouteTitleKey: ROUTES.articleList.path },
    children: [
      {
        path: "",
        name: "article_list_list",
        component: () => import("./article-list-list.view-DoMzLhRr.js"),
        meta: { requiredRight: "navigate_list_article_list" }
      },
      {
        path: "new",
        name: "article_list_new",
        component: () => import("./article-list-edit.view-CIjJFiOB.js"),
        props: () => ({
          title: getI18n().t("articleList.newArticleList"),
          backRoute: "/article-list"
        }),
        meta: { requiredRight: ["navigate_article_list"] }
      },
      {
        path: ":id",
        name: "article_list_detail",
        component: () => import("./article-list-edit.view-CIjJFiOB.js"),
        props: (route) => ({
          title: getI18n().t("articleListEdit.editArticleList"),
          id: route.params.id,
          backRoute: "/article-list"
        }),
        meta: { requiredRight: ["navigate_article_list"] }
      }
    ]
  }
];
const entityEndpoint = "article-list";
const ArticleListService = registerEntityEndpoint(entityEndpoint);
const { getEntity, listEntities, putEntity, postEntity, deleteEntity } = ArticleListService;
const getArticleListList = async (search, params = {}) => {
  return listEntities({ params: { search, ...params } });
};
const getArticleList = async (id) => {
  return getEntity(id);
};
const postArticleList = async (articleList) => {
  return postEntity(articleList);
};
const putArticleList = async (articleList) => {
  const { _id, ...payload } = articleList;
  return putEntity(_id, payload);
};
const removePreviouslySelectedArticleFromList = async (listId, articleId) => {
  return deleteEntity(`${listId}/previously-selected-article`, { data: { articleId } });
};
const deleteArticleList = async (id) => {
  return deleteEntity(id);
};
const getEmptyArticleList = () => ({
  title: "",
  brand: "bunte",
  articles: [],
  articlesPreviouslySelected: [],
  isDeleted: false
});
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "article-list-selector",
  props: {
    brand: { type: String, required: false },
    modelValue: { type: String, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const emit = __emit;
    const props = __props;
    const displayedOptions = ref([]);
    const previewOptions = computed(() => {
      return displayedOptions.value.map(
        (list) => ({
          label: list.title,
          value: list._id
        })
      );
    });
    const model = computed({
      get() {
        return props.modelValue ?? "";
      },
      set(selection) {
        const setModel = typeof selection === "object" ? selection.value : selection;
        emit("update:modelValue", setModel);
      }
    });
    onMounted(async () => {
      if (props.brand) {
        const { list } = await getArticleListList(void 0, { brand: props.brand });
        displayedOptions.value = list;
      }
    });
    const __returned__ = { t, emit, props, displayedOptions, previewOptions, model, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    ref: "articleListSelect",
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    "data-qa-channel-block-article-list-selector": "",
    outlined: "",
    dense: "",
    label: $setup.t("articleList.articleListLabel"),
    options: $setup.previewOptions,
    "map-options": "",
    "dropdown-icon": "expand_more"
  }, null, 8, ["modelValue", "label", "options"]);
}
const articleListSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/article-list/editor-ui/src/selectors/article-list-selector.vue"]]);
const articleListModule = {
  messages,
  routes,
  contentBlocks: []
};
export {
  ArticleListService as A,
  _export_sfc as _,
  getArticleList as a,
  postArticleList as b,
  articleListModule as c,
  deleteArticleList as d,
  articleListSelector as e,
  getEmptyArticleList as g,
  putArticleList as p,
  removePreviouslySelectedArticleFromList as r
};
//# sourceMappingURL=index-BLDXTzTN.js.map
